import { Button } from "@/components/ui/button";
import { ChevronLeft, ChevronRight } from "lucide-react";

// Flechas de navegación anterior/siguiente reutilizables. Se deshabilitan en los extremos.
export default function NavFlechas({
  onPrev,
  onNext,
  prevDisabled,
  nextDisabled,
  testid = "nav",
  labelPrev = "Anterior",
  labelNext = "Siguiente",
}) {
  return (
    <div className="inline-flex items-center rounded-lg border border-slate-200 overflow-hidden" data-testid={testid}>
      <Button
        variant="ghost"
        size="sm"
        className="h-9 rounded-none px-2.5 text-slate-600 hover:bg-slate-100 disabled:opacity-40"
        onClick={onPrev}
        disabled={prevDisabled}
        data-testid={`${testid}-prev`}
        aria-label={labelPrev}
        title={labelPrev}
      >
        <ChevronLeft size={16} />
      </Button>
      <div className="w-px h-5 bg-slate-200" />
      <Button
        variant="ghost"
        size="sm"
        className="h-9 rounded-none px-2.5 text-slate-600 hover:bg-slate-100 disabled:opacity-40"
        onClick={onNext}
        disabled={nextDisabled}
        data-testid={`${testid}-next`}
        aria-label={labelNext}
        title={labelNext}
      >
        <ChevronRight size={16} />
      </Button>
    </div>
  );
}
